<!--
	its frontend

	Page, submodule from App

    @file         Page_hello.svelte
    @author       Robert Fischer, fischer@tForge.eu
    @date         05/2022
    @copyright    tForge
-->


<script>
    import { PAGE }  from './config';
    import { URL_API, URL_IMG } 	from './minions';

    import {createEventDispatcher}  from "svelte";
    let dispatch =  createEventDispatcher();



// ============================ store variables ==============================

    import { st_login } from './stores';

    let login;
    st_login.subscribe(value => {
        login = value;
    });



// ======================== Analysis steps in Backend ========================

    let uploadFilename;
    let imageFilename;
    let imgSrc;
    let busy_calculateDeltaE = false;
    let busy_calculateDeltaC = false;
    let profiles_ready = false;
    let deltaE_ready = false;
    let deltaC_ready = false;

    let deltaE_testPassed = false;
    let data_dE_maxMeasured = 0;

    let data_dE;
    let data_dE_cmR;
    let data_dC;
    let data_dC_cmR;
    let data_dL;
    let data_dL_cmR;


    const imageUpload = async ()=> {

        let pa = document.getElementById("imageUploadDOMEl");

        pa.onchange = async evt=> {

            let file = evt.target.files[0];
            if (file) {
                uploadFilename = file?.name || "no known filename";
                const formImg = new FormData();
                formImg.append('imageFile', file);
                formImg.append('jsonStr', JSON.stringify({...login, flip:true}));

                const reply = await fetch(URL_API("upload_image"), {
                            method:'post',
                            body: formImg
                        })
                    .catch( err=> {
                        console.log('image upload failed')
                    });

                if (reply && reply.ok) {

                    const data = await reply.json();
                    imageFilename = data["imageFilename"];
                    imgSrc = URL_IMG(imageFilename);

                    analyzeImage();
                }
                else {
                    dispatch('message', {text: "Failed to connect to server."});
                }
            }
        }

        pa.click();

        profiles_ready = false;
        deltaE_ready = false;
        deltaC_ready = false;

    };//imageUpload()


    const analyzeImage = async ()=> {


        const reply = await fetch(URL_API("lipro/analyze_image"), {
                method:'post',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    ...login, imageFilename: imageFilename
                }
                )});

        if (reply && reply.ok) {
            const data = await reply.json();

            // show image with rois
            imgSrc = URL_IMG(data["imageFilename"]);

            // Plot proifiles
            Plotly.newPlot('plotHor', data.plotHor);
            Plotly.newPlot('plotVer', data.plotVer);
            profiles_ready = true;

            busy_calculateDeltaE = true;
            checkDeltaE();

        }
        else {
            console.log('analyze image failed');
            
        }

    };//analyzeImage()


    const checkDeltaE = async ()=> {

        busy_calculateDeltaE = true;

        const reply = await fetch(URL_API("lipro/check_deltae"), {
                method:'post',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    ...login, imageFilename: imageFilename
                }
                )});

        if (reply && reply.ok) {
            const data = await reply.json();
            data_dE = data.halfScale.data[0].z;
            data_dE_cmR = data.cmScale.data[0].z;

            Plotly.newPlot('plotDeltaE', data.halfScale);
            Plotly.newPlot('plotDeltaE_cmR', data.cmScale);

            deltaE_testPassed = data.testPassed;
            data_dE_maxMeasured = data.maxDE;
            maxScale_dE = data.maxAllowedDeltaE;
            deltaE_ready = true;
        }
        else {
            console.log('checkDeltaE failed');
        }

        busy_calculateDeltaE = false;

    };//checkDeltaE()


    const checkColor = async (illum)=> {

        busy_calculateDeltaC = true;


        const reply = await fetch(URL_API("lipro/check_color/" + illum), {
                method:'post',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    ...login, imageFilename: imageFilename
                }
                )});

        if (reply && reply.ok) {
            const data = await reply.json();
            data_dC = data.deltaC_plot.data[0].z;
            data_dC_cmR = data.deltaC_plot_cmR.data[0].z;
            data_dL = data.deltaL_plot.data[0].z;
            data_dL_cmR = data.deltaL_plot_cmR.data[0].z;

            Plotly.newPlot('plotDeltaC', data.deltaC_plot);
            Plotly.newPlot('plotDeltaC_cmR', data.deltaC_plot_cmR);
            Plotly.newPlot('plotDeltaL', data.deltaL_plot);
            Plotly.newPlot('plotDeltaL_cmR', data.deltaL_plot_cmR);
            deltaC_ready = true;
        }
        else {
            console.log('checkDeltaE failed');
        }

        busy_calculateDeltaC = false;

    };//checkColor()




// ========================== Interactive y-scaling ==========================


    let maxScale_dE = 20;
    let maxScale_dC = 20;
    let maxScale_dL = 20;


    const update_maxScale = plotname => {

        let minScale = 0;
        let maxScale = 50;
        if (plotname.includes("plotDeltaE")){
            maxScale = maxScale_dE;
        }
        else if  (plotname.includes("plotDeltaC")){
            maxScale = maxScale_dC;
        }
        else if (plotname.includes("plotDeltaL")){
            maxScale = maxScale_dL;
            minScale = - maxScale_dL;
        }
        else {
            return;
        }

        const plotUpdate = {'zmin': minScale, 'zmax': maxScale};
        Plotly.update(plotname, plotUpdate, {}, [0]);
        Plotly.update(plotname + '_cmR', plotUpdate, {}, [0]);

    };//update_maxScale_dE()


    const exportData = plotname => {

        let rows = [];
        if (plotname == "plotDeltaE_cmR"){
            rows = data_dE_cmR;
        }
        else if (plotname == "plotDeltaE"){
            rows = data_dE;
        }
        else if  (plotname.includes("plotDeltaC")){
            rows = data_dC;
        }
        else if (plotname.includes("plotDeltaL")){
            rows = data_dL;
        }
        else {
            return;
        }
        rows.reverse();

        let csvContent = "data:text/csv;charset=utf-8,";
        rows.forEach(function(rowArray) {
            let row = rowArray.join(", ");
            csvContent += row + "\r\n";
        });

        var encodedUri = encodeURI(csvContent);
        let dl = document.createElement("a");
        dl.setAttribute("href", encodedUri);
        dl.setAttribute("download", `${plotname}.csv`);
        document.body.appendChild(dl); // Required for FF
        dl.click();

    };//exportData()



// ========================== Construction / Init ============================

    import { onMount, onDestroy } 	from 'svelte';


    onMount(async () => {

    });//onMount()


    function close(nextPage=PAGE.home) {
        dispatch('close', {page: nextPage});
    }//close()


	onDestroy(async () => {

	});//onDestroy()

</script>




<!-- =============================  H T M L  ============================= -->

<div class="page">

    <h1>LiPro</h1>

    <h3>Illumination profiles</h3>

    <div class="btn" on:click={imageUpload}>
        Upload an image
    </div>

    <!-- Show uploaded image, incl. marker of regions used for profile analysis -->
    {#if imgSrc}
    <p class="filename">Source image: {uploadFilename}</p>

    <div class="box">
        <img src={imgSrc} alt="">
    </div>
    {/if}

    <!-- Profile analysis  -->
    <div class="box" class:hide={!profiles_ready}>
        <div class="plot" id="plotHor"></div>
    </div>

    <div class="box" class:hide={!profiles_ready}>
        <div class="plot" id="plotVer"></div>
    </div>


    <!-- deltaE from mean value -->
    {#if busy_calculateDeltaE}
        <h3>... calculating and plotting deltaE value for each pixel, please wait ...</h3>
    {/if}

    <div class="box" class:hide={!deltaE_ready}>
        <div class="plotHeaderRow">
            <div class="btn" on:click={()=> exportData('plotDeltaE')}>
                Export data
            </div>

            <div class="box-input">
                <label for="maxScale_dE">Scale maximum</label>
                <input id="maxScale_dE"  class="input-txt"
                    bind:value={maxScale_dE} on:input={()=>update_maxScale('plotDeltaE')}
                    type="number" min="5" max="100" pattern="\d*">
            </div>
        </div>
        <div class="plot" id="plotDeltaE"></div>
    </div>
    <div class="box" class:hide={!deltaE_ready}>
        <div class="plotHeaderRow">
            <div class="btn" on:click={()=> exportData('plotDeltaE_cmR')}>
                Export data
            </div>

            <div class="box-input">
                <label for="maxScale_dE">Scale maximum</label>
                <input id="maxScale_dE_cmR"  class="input-txt"
                    bind:value={maxScale_dE} on:input={()=>update_maxScale('plotDeltaE')}
                    type="number" min="5" max="100" pattern="\d*">
            </div>
        </div>
        <div class="plot" id="plotDeltaE_cmR"></div>


        {#if deltaE_testPassed}
            <div class="msgPass">Test passed (max deltaE: {data_dE_maxMeasured.toFixed(2)})</div>
        {:else}
            <div class="msgPass msgFail">Test failed (max deltaE: {data_dE_maxMeasured.toFixed(2)})</div>
        {/if}
    </div>        


    <!-- User select type of plate image -->
    <div class="btnRow" class:hide={!deltaE_ready}>
        <h3>Select plate image type to calculate deltaC and deltaL</h3>
    </div>
    <div class="btnRow" class:hide={!deltaE_ready}>
        <div class="btn" on:click={()=> checkColor('WHITE')}>
            White (220, 215, 210)
        </div>
        <div class="btn" on:click={()=> checkColor('GREEN')}>
            Green (0, 250, 60)
        </div>
        <div class="btn" on:click={()=> checkColor('BLUE')}>
            Blue (60, 210, 210)
        </div>
    </div>


    {#if busy_calculateDeltaC}
    <h3>... calculating and plotting deltaC value for each pixel, please wait ...</h3>
    {/if}


    <!-- deltaC -->
    <div class="box" class:hide={!deltaC_ready}>
        <div class="plotHeaderRow">
            <div class="btn" on:click={()=> exportData('plotDeltaC')}>
                Export data
            </div>

            <div class="box-input">
                <label for="maxScale_dC">Scale maximum</label>
                <input id="maxScale_dC" class="input-txt"
                    bind:value={maxScale_dC} on:input={()=>update_maxScale('plotDeltaC')}
                    type="number" min="5" max="100" pattern="\d*">
            </div>
        </div>
        <div class="plot" id="plotDeltaC"></div>
    </div>
    <div class="box" class:hide={!deltaC_ready}>
        <div class="plotHeaderRow">
            <div class="btn" on:click={()=> exportData('plotDeltaC_cmR')}>
                Export data
            </div>

            <div class="box-input">
                <label for="maxScale_dC">Scale maximum</label>
                <input id="maxScale_dC" class="input-txt"
                    bind:value={maxScale_dC} on:input={()=>update_maxScale('plotDeltaC')}
                    type="number" min="5" max="100" pattern="\d*">
            </div>
        </div>
        <div class="plot" id="plotDeltaC_cmR"></div>
    </div>

    <!-- deltaL -->
    <div class="box" class:hide={!deltaC_ready}>
        <div class="plotHeaderRow">
            <div class="btn" on:click={()=> exportData('plotDeltaL')}>
                Export data
            </div>

            <div class="box-input">
                <label for="maxScale_dL">Scale maximum</label>
                <input id="maxScale_dL" class="input-txt"
                    bind:value={maxScale_dL} on:input={()=>update_maxScale('plotDeltaL')}
                    type="number" min="5" max="100" pattern="\d*">
            </div>
        </div>
        <div class="plot" id="plotDeltaL"></div>
    </div>
    <div class="box" class:hide={!deltaC_ready}>
        <div class="plotHeaderRow">
            <div class="btn" on:click={()=> exportData('plotDeltaL')}>
                Export data
            </div>

            <div class="box-input">
                <label for="maxScale_dL">Scale maximum</label>
                <input id="maxScale_dL" class="input-txt"
                    bind:value={maxScale_dL} on:input={()=>update_maxScale('plotDeltaL')}
                    type="number" min="5" max="100" pattern="\d*">
            </div>
        </div>
        <div class="plot" id="plotDeltaL_cmR"></div>
    </div>

</div>

<input id="imageUploadDOMEl" name="imageFile" type="file" accept="image/jpeg"  style="display:none;"/>






<!-- ============================  S T Y L E  ============================ -->



<style>
	.page {
        width: 100%;
        max-width: 1400px;
        margin-top: 2em;
        margin-left: auto;
        margin-right: auto;
        padding: 2em;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    h1 {
        margin-top: 3em;
    }
    
    .filename{
        color: var(--tF-blue);
        font-weight: bold;
        font-size: 1.2em;
        margin: 1em;
    }
    h3 {
        border-top: 1px solid var(--tF-gray);
        padding: 1em 2em;
        margin: 1em auto;
        /* for print / pdf */
        /* page-break-before: always; */
    }
    .btn {
        width: 20em;
    }

    .box {
        margin-top: 3em;
        width: 90%;
        max-width: 1400px;
        /* for print / pdf */
        page-break-before: auto;
        page-break-inside: avoid; 
    }

    .box img{
        width: 100%;
        max-width: 1200px;
        object-fit: contain;
    }

    .plot {
        width: 100%;
        min-height: 800px;
        overflow: hidden;
        margin-bottom: 3em;
        margin-left: 0px;
    }

    .btnRow {
        width: 100%;
        margin: auto;
        margin-top: 4em;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .plotHeaderRow {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 0.5em;
        align-items: flex-end;
    }

    .msgPass {
        width: 100%;
        padding: 3em;
        background-color: darkgreen;
        color: white;
        font-size: 1.5em;
    }
    .msgFail {
        background-color: darkred;
    }

</style>